import Axios from 'axios'

const biDeliveryPerformance = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BASE_URL_API + '/dashboard/bi/v1'
    return AxiosInstance
  },

  getDeliveryPerformance(period) {
    return this.axios().get('/performance-entrega', {
      params: { periodo: period },
    })
  },
}

export default biDeliveryPerformance